export const RELOAD = 'RELOAD';
export const SET_LOADING = 'SET_LOADING';
export const EXIT_FULLSCREEN = 'EXIT_FULLSCREEN';
export const LOAD_ALBUM = 'LOAD_ALBUM';
export const CLEAR_PAGE = 'CLEAR_PAGE';
export const LOAD_COMMENTS = 'LOAD_COMMENTS';
export const SET_INDEX = 'SET_INDEX';
